import ClickOutsideListener from "./ClickOutsideListener";

export default ClickOutsideListener;
